import type { AllRouteEndpoints } from "../routeTypes";
export const appsUserInfoDeleteUsersFromSegmentCacheKeys: AllRouteEndpoints[] = [
  "/apps/user_info/user_deletion_record_datatable",
];
